import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Label,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ImageUpload from "../../components/CustomUpload/ImageUpload";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import { Utilites } from "../../core/Utilites";

export default class MerchantItemAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      merchantlist: [],
      merchantId: "",
      branchlist: [],
      branchId: "",
      code: "",
      description: "",
      imageUrl: "",
      isImageChanged: false,
      loading: false,
    };

    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedMerchant } = this.props.match.params;
    this.pathname = `merchants/${selectedMerchant}/items`;
    const edit = this.props.location.data;

    if (edit) {
      this.setState({
        ...edit,
        customer: edit.customer && edit.customer.id,
      });
    }

    this.fetchBranches(selectedMerchant);
  }

  async fetchBranches(selectedMerchant) {
    try {
      const responseuni = await this.engine.getItemlistDirect(
        `merchants/${selectedMerchant}/branches`
      );
      if (responseuni) {
        const data = responseuni.data.items;
        let branchlist = data.map((p) => ({
          value: p.id,
          label: p.name || p.address || (p.area && p.area.name) || "-",
        }));
        this.setState({ branchlist });
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  }

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const { id, branchId, merchantId, imageUrl, isImageChanged, ...data } =
      this.state;
    const { selectedMerchant } = this.props.match.params;
    let response;
    try {
      if (id) {
        if (!isImageChanged) delete data.imageUrl;
        else data["imageUrl"] = this.idFileBase64;

        response = await this.engine.updateItem(this.pathname, id, data);
      } else {
        const { title, code, description, branchId } = this.state;
        const postData = {
          imageUrl: this.idFileBase64,
          title,
          description,
          code,
          merchantId: selectedMerchant,
          branchId,
        };
        if (branchId === "") delete postData.branchId;

        response = await this.engine.saveItem(this.pathname, postData);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push(`/admin/merchant/${selectedMerchant}/items`);
      }
    } catch (err) {
      if (imageUrl === "") alert(strings.select + " " + strings.picture);
      else if (err.response && err.response.status === 400) {
        alert("Error: " + err.response.data.message.join(", "));
      } else {
        alert("An unexpected error occurred: " + err.message);
      }
    }

    this.setState({ loading: false });
  };

  onChangePic(e) {
    if (!e.target.files[0]) {
      return; // No file selected, return early
    }

    Utilites.getFileBase64(e.target.files[0], (result) => {
      this.setState({ imageUrl: result, isImageChanged: true });
      this.idFileBase64 = result; // Only update if new file is selected
    });
  }

  render() {
    const { loading, isLoading, code, description, branchId, branchlist, id } =
      this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <h4>{strings.information}</h4>
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={() => this.handleValidSubmit()}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  {!id && (
                    <SelectRow
                      label={strings.branch}
                      name="branchId"
                      defaultValue={branchId}
                      data={branchlist}
                      changeInput={this.changeInput.bind(this)}
                    />
                  )}
                  <FormRow
                    label={strings.code}
                    name="code"
                    data={code}
                    changeInput={this.changeInput.bind(this)}
                  />
                  <FormRow
                    label={strings.description}
                    name="description"
                    data={description}
                    changeInput={this.changeInput.bind(this)}
                  />
                  <Row>
                    <Label sm="2">{strings.picture}</Label>
                    <Col sm="5">
                      <FormGroup>
                        <ImageUpload
                          placeholder={
                            this.state.imageUrl ||
                            strings.select + " " + strings.picture
                          }
                          labelupload={strings.select + " " + strings.picture}
                          onChange={(e) => this.onChangePic(e)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
